<template>
    <v-container fluid>
        <div v-if="!dataLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Stock Transfer Receipt #{{data.code}}</h4>
                    <p class="text-subtitle-1">Stock Transfer Vouchers Modification Form</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <TransferReceiptVoucherForm v-model="data"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn color="primary" block @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn depressed block @click="handleCancel">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>

                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import TransferReceiptVoucherForm from '../../../components/warehouse/transfer/TransferReceiptVoucherForm.vue';
import stockTransferReceiptAPI from '../../../services/stockJournal/stockTransferReceipt';
import { v4 as uuid } from 'uuid';
import PAlert from '../../../components/common/PAlert.vue';


export default {
    components: {
        TransferReceiptVoucherForm,
        PAlert
    },
    data() {
        return {
            data: {},
            dataLoading: false,
            loading: false,
            id: null,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
        }
    },
    methods: {
        fetch() {
            this.dataLoading = true;
            stockTransferReceiptAPI.find(this.id).then(response => {
                let res = response.data;
                let d = {
                    ...res,
                    source_warehouse_id: res.source_warehouse.id,
                    target_warehouse_id: res.target_warehouse.id,
                    stock_transfer_id: res.stock_transfer.id,
                    stock_transfer_code: res.stock_transfer.code,
                    lines: res.lines.map(line => {
                        return {
                            ...line,
                            item: line.item,
                            item_id: line.item.id,
                            measure_unit: line.measure_unit,
                            measure_unit_id: line.measure_unit.id,
                            quantity: line.quantity,
                            key: uuid()
                        }
                    })
                }

                this.data = d
            }).finally(() => {
                this.dataLoading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, content: "Are you sure you want to discard changes?", value: true, callback: this.cancel }
        },
        cancel() {
            this.$router.back();
        },
        handleSave() {
            this.alert = {...this.alert, content: "Are you sure you want to save?", value: true, callback: this.save }
        },
        save() {
            this.loading = true;
            stockTransferReceiptAPI.update(this.data).then(response => {
                this.$router.replace({
                    name: "TransferReceiptVoucherDisplay",
                    params: {
                        id: response.data.id
                    }
                })
            }).finally(() => {
                this.loading = false;
            })
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.fetch();
    }
}
</script>

<style>

</style>